import React from 'react';

const RiskInvestigationMessage = () => {

    return (
        <>
            <span>The Agent code is under 'Risk Investigation' and hence business sourcing is restricted. Please reach Risk Team on email id  <a href="mailto:Fraud.prevention@edelweisslife.in"> <b style={{ color: " #134093" }}> Fraud.prevention@edelweisslife.in </b> </a> for further clarification.</span>
        </>
    )
}
export default RiskInvestigationMessage;